/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateRoleRequest } from '../models/CreateRoleRequest';
import type { DeleteRoleRequest } from '../models/DeleteRoleRequest';
import type { MemberEntityAccess } from '../models/MemberEntityAccess';
import type { RoleAssignmentsCreatePayload } from '../models/RoleAssignmentsCreatePayload';
import type { RoleAssignmentWarning } from '../models/RoleAssignmentWarning';
import type { RoleRead } from '../models/RoleRead';
import type { RoleReorder } from '../models/RoleReorder';
import type { RoleWithAssignments } from '../models/RoleWithAssignments';
import type { UpdateRoleRequest } from '../models/UpdateRoleRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class RolesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create Role
     * @param namespaceId
     * @param requestBody
     * @returns RoleRead Successful Response
     * @throws ApiError
     */
    public createRole(
        namespaceId: string,
        requestBody: CreateRoleRequest,
    ): CancelablePromise<RoleRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/roles/create-role/{namespace_id}',
            path: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Roles With Assignments For Namespace
     * @param namespaceId
     * @returns RoleWithAssignments Successful Response
     * @throws ApiError
     */
    public listRolesWithAssignmentsForNamespace(
        namespaceId: string,
    ): CancelablePromise<Array<RoleWithAssignments>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/roles/list-roles-with-assignments-for-namespace/{namespace_id}',
            path: {
                'namespace_id': namespaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Role
     * @param roleId
     * @param requestBody
     * @returns RoleRead Successful Response
     * @throws ApiError
     */
    public updateRole(
        roleId: string,
        requestBody: UpdateRoleRequest,
    ): CancelablePromise<RoleRead> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/roles/update-role/{role_id}',
            path: {
                'role_id': roleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Role
     * @param roleId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteRole(
        roleId: string,
        requestBody?: (DeleteRoleRequest | null),
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/roles/delete-role/{role_id}',
            path: {
                'role_id': roleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reorder Roles
     * @param namespaceId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public reorderRoles(
        namespaceId: string,
        requestBody: RoleReorder,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/roles/reorder-roles/{namespace_id}',
            path: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Member Entity Access For Cluster
     * @param clusterId
     * @returns MemberEntityAccess Successful Response
     * @throws ApiError
     */
    public listMemberEntityAccessForCluster(
        clusterId: string,
    ): CancelablePromise<Array<MemberEntityAccess>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/roles/list-member-entity-access',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Role Assignments For Cluster
     * @param clusterId
     * @param requestBody
     * @returns RoleAssignmentWarning Successful Response
     * @throws ApiError
     */
    public saveRoleAssignmentsForCluster(
        clusterId: string,
        requestBody: RoleAssignmentsCreatePayload,
    ): CancelablePromise<Array<RoleAssignmentWarning>> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clusters/{cluster_id}/roles/save-role-assignments-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
